import MainDenegadas from '@/views/administracion/denegadas/Main.vue';

const denegadas = [
  {
    path: 'denegadas',
    meta: {
      title: '',
      auth: [],
    },
    component: MainDenegadas,
    children: [
      {
        name: 'rutarestringida',
        path: '/',
        meta: {
          title: 'RutaRestringida',
          auth: true,
        },
        component: MainDenegadas,

        children: [],
      },
    ],
  },
];

export default denegadas;
